import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';
import Table from '../table';


const VehicleEventsInGeoZoneTable = ({
  data,
  t,
}) => (
  <Table hover responsive="sm" size="md" isEmpty={_.isEmpty(data)} emptyMessage={t('messages.noData')}>
    <thead>
      <tr>
        <th className="align-middle">{ t('id.geozoneName') }</th>
        <th className="align-middle">{ t('time.start_time') }</th>
        <th className="align-middle">{ t('time.end_time') }</th>
        <th className="align-middle">{ t('time.duration') }</th>
      </tr>
    </thead>
    <tbody>
      { _.map(data, (event, index) => (
        <tr key={index}>
          <td className="align-middle">
            {event.zone}
          </td>
          <td className="align-middle">
            {moment(event.start_time).format('D MMMM YYYY HH:mm')}
          </td>
          <td className="align-middle">
            {moment(event.end_time).format('D MMMM YYYY HH:mm')}
          </td>
          <td className="align-middle">
            {event.duration}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>

);


VehicleEventsInGeoZoneTable.propTypes = {
  data: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation(),
)(VehicleEventsInGeoZoneTable);
